import React from "react";
import { cn } from "../utils";

/**
 * 2px indeterminate brand bar. By default it sits at the top of its parent,
 * which needs `relative overflow-hidden`. `fixed` pins it under the header.
 */
export function TopProgressBar({ active, fixed = false, className }) {
  if (!active) return null;
  return (
    <div
      aria-hidden="true"
      className={cn("aone-progress", fixed && "aone-progress--fixed", className)}
    >
      <span />
    </div>
  );
}

export default TopProgressBar;
